<template>
    <div class="alarm-status">
        <h4>Alarmas</h4>
        <div class="table-responsive">
            <table class="table table-condensed table-bordered table-hover table-sm">
                <thead class="thead-orange">
                    <tr>
                        <th>Nombre</th>
                        <th>Mensaje</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(alarm, i) in alarms" :key="i">
                        <td>{{ alarm.name }}</td>
                        <td>{{ alarm.message }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    
    export default {
        computed: {
            ...mapGetters(['alarms'])
        }
    }
</script>